import { Tenants, TenantsFilters } from './../../../commons/models/tenants';
import { ViewChild, Component, EventEmitter, Input, Output } from "@angular/core";

// Angular Material
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
// Rxjs
import { first, Observable } from "rxjs";
import { state, style, trigger } from '@angular/animations';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';

export type TenantsColumn = "name" | "address" | "phone" | "city" | "actions";


@Component({
  selector: "app-tenants-list",
  templateUrl: "./tenants-list.component.html",
  styleUrls: ["./tenants-list.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
    ]),
  ],
})
export class TenantsListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  tenants: Tenants[];

  // constructor() {
  //   console.log(this.tenants);
  // }
  
  @Input()
  selectedTenants: Tenants[];

  @Input()
  defaultFilters: TenantsFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: Tenants | null;

  @Input()
  total: Observable<number>;
  @Input()
  displayedColumns: string[] = ['name', 'address', 'phone', 'city', 'actions'];

  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<TenantsFilters> = new EventEmitter<TenantsFilters>();

  @Output()
  onSelectTenant: EventEmitter<Tenants> = new EventEmitter<Tenants>();
  @Output()
  onAddTenant: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditTenant: EventEmitter<Tenants> = new EventEmitter<Tenants>();
  @Output()
  onShowTenant: EventEmitter<Tenants> = new EventEmitter<Tenants>();
  @Output()
  onAddSelectedTenant: EventEmitter<Tenants> = new EventEmitter<Tenants>();
  @Output()
  onRemoveSelectedTenant: EventEmitter<Tenants> = new EventEmitter<Tenants>();
  @Output()
  onGenerateInvoice: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onCanceledInvoices: EventEmitter<Tenants> = new EventEmitter<Tenants>();

  get selectedItems(): boolean {
    return this.selectedTenants.length > 0;
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  isSelected(tenant: Tenants): boolean {
    return this.selectedTenants.map(obj => obj.id).includes(tenant.id)
  }

  addTenant() {
    this.onAddTenant.emit();
  }

  addSelectedTenant(tenant: Tenants) {
    if(this.isSelectable(tenant)) {
      this.onAddSelectedTenant.emit(tenant);
    }
  }

  isSelectable(tenant: Tenants): boolean {
    return !tenant.id
  }

  removeSelectedTenant(tenant: Tenants) {
    this.onRemoveSelectedTenant.emit(tenant)
  }

  toggleSelectedTenant(tenant: Tenants) {
    if (this.isSelected(tenant)) {
      this.removeSelectedTenant(tenant);
    } else {
      this.addSelectedTenant(tenant);
    }
  }

  editTenant(tenant: Tenants) {
    this.onEditTenant.emit(tenant);
  }

  selectTenant(tenant: Tenants) {
    this.onSelectTenant.emit(tenant);
  }

  onFilter(filters: TenantsFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
    //console.log("firstpage:", this.paginator.firstPage());
  }

  showTenant(activityList: Tenants) {
    this.onShowTenant.emit(activityList);
  }

  canceledInvoices(tenant: Tenants) {
    this.onCanceledInvoices.emit(tenant);
  }

  generateInvoice() {
    this.onGenerateInvoice.emit();
  }

  isAllSelected() {
    const numSelected = this.selectedTenants.length;
    const numRows = this.tenants.filter(bl => this.isSelectable(bl)).length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selectedTenants.forEach(bl => this.removeSelectedTenant(bl)) :
        this.tenants.forEach(bl => this.addSelectedTenant(bl));
  }

}
